import React from "react";
import { Link, useParams } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { isEmpty } from "lodash";

//Import Breadcrumb
import Breadcrumbs from "../../Components/Common/Breadcrumb";

// img
import logo from "../../assets/images/logo/pappermap-logo-wordmark.png";
import Spinners from "Components/Common/Spinner";
// import { readableDate } from "utils";
import { AppRoutes } from "../../constants";
import { useSelector } from "react-redux";
import { useGetProductTransferById } from "hooks/useProductTransfer";
import { readableDate } from "utils";

const ProductTransferDetails = (props: any) => {
  //meta title
  document.title = "Papermap | Product Transfer Details";

  const { id } = useParams();
  const { data: productTransferData, isLoading } = useGetProductTransferById(
    id || ""
  );
  const defaultCurrency = useSelector(
    (state: any) => state.Login.default_currency
  );

  //Print the Invoice
  const printInvoice = () => {
    window.print();
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Product Transfer" breadcrumbItem="Details" />
          {isLoading ? (
            <Spinners />
          ) : (
            !isEmpty(productTransferData) && (
              <Row>
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <div className="invoice-title">
                        <h4 className="float-end font-size-16">
                          Product Transfer # {productTransferData?.id}
                        </h4>
                        <div className="auth-logo mb-3">
                          <img src={logo} alt="logo" height="20" />
                        </div>
                      </div>
                      <hr />
                      <Row>
                        <Col sm={5}>
                          <div className="d-flex align-items-center mb-3">
                            <i
                              className="mdi mdi-arrow-up-circle-outline text-primary me-2"
                              style={{ fontSize: "1.2rem" }}
                            ></i>
                            <h6
                              className="mb-0 text-primary"
                              style={{ fontSize: "0.9rem" }}
                            >
                              Source Details
                            </h6>
                          </div>

                          <address>
                            <strong>Source branch:</strong>
                            <br />
                            {productTransferData?.from_branch?.name}
                            <br />
                            {productTransferData?.from_branch?.address}
                          </address>
                          <address>
                            <strong>Product:</strong>
                            <br />
                            {productTransferData?.from_product?.name}
                          </address>
                          <address>
                            <strong>Product Price:</strong>
                            <br />
                            {defaultCurrency}{" "}
                            {productTransferData?.from_product?.selling_price?.toFixed(
                              2
                            )}
                          </address>
                          <address>
                            <strong>Transfer quantity:</strong>
                            <br />
                            {productTransferData?.from_quantity}
                          </address>
                        </Col>
                        <Col
                          sm={2}
                          className="d-flex align-items-center justify-content-center"
                        >
                          <i
                            className="d-none d-sm-block mdi mdi-swap-horizontal text-primary opacity-75"
                            style={{ fontSize: "4rem" }}
                          ></i>
                          <i
                            className="d-sm-none mdi mdi-swap-vertical text-primary opacity-75"
                            style={{ fontSize: "4rem" }}
                          ></i>
                        </Col>
                        <Col sm={5} className="text-sm-end">
                          <h6
                            className="mb-3 text-primary"
                            style={{ fontSize: "0.9rem" }}
                          >
                            <i
                              className="mdi mdi-arrow-down-circle-outline text-primary me-2"
                              style={{ fontSize: "1.2rem" }}
                            ></i>
                            Target Details
                          </h6>
                          <address>
                            <strong>Target branch:</strong>
                            <br />
                            {productTransferData?.to_branch?.name}
                            <br />
                            {productTransferData?.to_branch?.address}
                          </address>
                          <address>
                            <strong>Product:</strong>
                            <br />
                            {productTransferData?.to_product?.name}
                          </address>
                          <address>
                            <strong>Product Price:</strong>
                            <br />
                            {defaultCurrency}{" "}
                            {productTransferData?.to_product?.selling_price?.toFixed(
                              2
                            )}
                          </address>
                          <address>
                            <strong>Transfer quantity:</strong>
                            <br />
                            {productTransferData?.to_quantity}
                          </address>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={6}>
                          <address>
                            <strong>Transfer by:</strong>
                            <br />
                            {productTransferData?.transferred_by_user?.email}
                          </address>
                        </Col>
                        <Col sm={6} className="text-sm-end">
                          <address>
                            <strong>Transfer date:</strong>
                            <br />
                            {readableDate(productTransferData?.transfer_date)}
                          </address>
                        </Col>
                      </Row>

                      <div className="d-print-none mt-3">
                        <hr />
                        <div className="float-end">
                          <Link
                            to="#"
                            onClick={printInvoice}
                            className="btn btn-success  me-2"
                          >
                            <i className="fa fa-print" />
                          </Link>
                          <Link
                            to={AppRoutes.PRODUCT_TRANSFERS}
                            className="btn btn-primary w-m"
                          >
                            Back
                          </Link>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ProductTransferDetails);
